import * as React from 'react';
import { Colors } from '../../../theme';
import ArrowDown from '../Icons/ArrowDown';
import * as S from './styles';
export const CustomAccordion = (props) => (React.createElement(S.StyledMuiAccordion, Object.assign({ disableGutters: true, elevation: 0, square: true }, props)));
export const CustomAccordionSummary = (props) => (React.createElement(S.StyledAccordionSummary, Object.assign({ expandIcon: React.createElement(ArrowDown, { color: Colors.grey900 }) }, props)));
export const CustomAccordionDetails = S.StyledAccordionDetails;
//# sourceMappingURL=index.js.map